<script setup>
import { useAppStore } from '@/stores/app.js'
import { storeToRefs } from 'pinia'

const appStore = useAppStore()

const {
  isPWAInstalled,
  deferredPromptPWAFunc
} = storeToRefs(appStore)

function pwaPrompt () {
  if (!appStore.deferredPromptPWAFunc) {
    return
  }

  appStore.deferredPromptPWAFunc.prompt()

  // Wait for the user to respond to the prompt
  appStore.deferredPromptPWAFunc.userChoice.then((choiceResult) => {
    if (choiceResult.outcome === 'accepted') {
      appStore.isPWAInstalled = true
    }

    appStore.deferredPromptPWAFunc = null
  })
}
</script>

<template>
  <div
    v-if="!isPWAInstalled && deferredPromptPWAFunc"
    class="p-3 flex flex-col items-center justify-center"
    style="background-color: #dbdaff; border-radius: 10px">
    <div class="mb-0.5 text-intermediate">⚡⚡⚡</div>

    <div
      class="text-center mb-1.5"
      style="color: #4756da">
      <h3 class="font-bold text-intermediate">{{ $t('modals.pwa.heading') }}</h3>
      <p>{{ $t('modals.pwa.descriptions') }}</p>
    </div>

    <button
      style="max-width: 185px; width: 100%"
      class="btn btn-purple pt-0.5 py-1 px-4 rounded-2xl text-caption"
      @click="pwaPrompt">
      <span class="flex items-center">
        <InlineSvg
          class="mr-0.5 text-transparent"
          :src="require('@/assets/svg/design/pwa/download-2.svg')"/>

        <span class="ml-1 font-semibold">{{ $t('modals.pwa.install_app') }}</span>
      </span>
    </button>
  </div>
</template>